import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function Menu(_: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <button
      className={styles.menu}
      onClick={() =>
        pushView({ key: UseCases.createCostProfile, data: undefined })
      }
    >
      <div className={styles.iconBox}>+</div>
      <p>{t("costProfilesPage.add")}</p>
    </button>
  );
}

export { Menu };
